<template>
  <div id="main">
    <!--上部分-->
    <div class="col-xs-12 col-sm-12 grid_div" id="grid_top_div">
      <div id="top_title">
        鄂尔多斯党校管理系统
      </div>
      <div id="tool">
        <!--<div id="setting">
          <img src="../assets/img/top/setting.png"/>
          <span>设置</span>
        </div>-->
        <div id="exit" @click="existSystem()">
          <img src="../assets/img/top/exit.png"/>
          <span>退出</span>
        </div>
      </div>
    </div>
    <!--左部分-->
    <div class="col-xs-2 col-sm-2 grid_div" id="grid_left_div">
      <div id="user_welcome">
        <div id="user_head_img">
          <img v-if="!photoPath || photoPath=='null'" src="../assets/img/left/left_img1.png"/>
          <img v-else :src="photoPath_all" width="100px" height="100px"/>
        </div>
        <table class="user_welcome_tab">
          <tr>
            <td colspan="2" class="userName">{{userName}}</td>
          </tr>
          <tr>
            <td>——</td>
            <td>{{workDept}}</td>
          </tr>
          <!--<tr v-if="deptCode == 'eas'">-->
          <!--<td>——</td>-->
          <!--<td>{{workJob}}</td>-->
          <!--</tr>-->
        </table>
      </div>
      <div id="menu" class="menu_div">
        <!-- 使用 router-link 组件来导航. -->
        <!-- 通过传入 `to` 属性指定链接. -->
        <!-- <router-link> 默认会被渲染成一个 `<a>` 标签 -->
        <router-link v-for="(menuLi,index) in menu_data" :key="index" :to="menuLi.url=='/setting'?'/placeSetting':menuLi.url">
          <div class="router_link_div" v-bind:class="{click_menu_option:menuLi.url == current_router_path}" @click="current_router_path = menuLi.url" :menuPathName="menuLi.url | format_path">
            <img v-if="menuLi.name === '首页'" src="../assets/img/left/index.png"/>
            <img v-else-if="menuLi.name === '我的任务'" src="../assets/img/left/task.png"/>
            <img v-else-if="menuLi.name === '班级管理'" src="../assets/img/left/class.png"/>
            <img v-else-if="menuLi.name === '网络课堂'" src="../assets/img/left/classroom.png"/>
            <img v-else-if="menuLi.name === '信息管理'" src="../assets/img/left/message.png"/>
            <img v-else-if="menuLi.name === '相关设置'" src="../assets/img/left/setting.png"/>
            <img v-else-if="menuLi.name === '批改作业'" src="../assets/img/left/homework.png"/>
            <img v-else-if="menuLi.name === '提交作业'" src="../assets/img/left/homework.png"/>
            <img v-else-if="menuLi.name === '分析统计'" src="../assets/img/left/workLoad.png"/>
            <img v-else-if="menuLi.name === '学习培训管理'" src="../assets/img/left/trainingManage.png"/>
            <img v-else-if="menuLi.name === '课程管理'" src="../assets/img/left/courseManage.png"/>
            <img v-else-if="menuLi.name === '课程库'" src="../assets/img/left/courseManage.png"/>
            <img v-else-if="menuLi.name === '师资库'" src="../assets/img/left/teacher.png"/>
            <img v-else-if="menuLi.name === '带班记录'" src="../assets/img/left/class.png"/>
            <img v-else-if="menuLi.name === '考勤管理'" src="../assets/img/left/checkmark.png"/>
            <img v-else-if="menuLi.name === '菜单管理'" src="../assets/img/left/cateringmenu.png"/>
            <img v-else-if="menuLi.name === '今日菜单'" src="../assets/img/left/cateringtoday.png"/>
            <img v-else-if="menuLi.name === '就餐记录'" src="../assets/img/left/cateringrecord.png"/>
            <img v-else-if="menuLi.name === '图书馆'" src="../assets/img/left/library.png"/>
            <img v-else-if="menuLi.name === '直播课管理'" src="../assets/img/left/live.png"/>
            <img v-else-if="menuLi.name === '课题管理'" src="../assets/img/left/ktgl.png"/>
            <img v-else-if="menuLi.name === '科研项目'" src="../assets/img/left/kyxm.png"/>
            <img v-else-if="menuLi.name === '课题征集管理'" src="../assets/img/left/ktzjgl.png"/>
            <img v-else-if="menuLi.name === '课题征集'" src="../assets/img/left/ktzj.png"/>
            <img v-else-if="menuLi.name === '数据驾驶舱'" src="../assets/img/left/sjjsc.png"/>
            <span>{{menuLi.name}}</span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 路由出口 -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  export default {
    name: "mainView",
    data() {
      return {
        userCode: this.$store.state.userCode,
        leaderUserCode: this.$store.state.leaderUserCode,
        easUserCode: this.$store.state.easUserCode,
        teacherClassUserCode:this.$store.state.teacherClassUserCode,
        teacherUserCode:this.$store.state.teacherUserCode,
        teacherClazzCode:this.$store.state.teacherClazzCode,

        photoPath: this.$store.state.photoPath,
        photoPath_all: this.$store.state.serviceBase + "resources/" + this.$store.state.photoPath,

        //菜单数据
        menu_data: [],

        classManageTea:{
          checked: false,
          children: [],
          childs: [],
          click: null,
          code: "classTea",
          icon: null,
          iconSkin: null,
          id: "3851a3e5deba44e9ad5f349ba35f9f5d",
          isParent: false,
          name: "带班记录",
          nodes: [],
          open: false,
          parentId: "45ab6945c94e4409b0cdc164a98b8f83",
          target: "mainFrame",
          url: "/classTea"
        },

        //目前选择的路由path
        current_router_path: this.$route.meta.parentPath?this.$route.meta.parentPath:this.$route.path,
        //密码
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        //用户名
        userName: this.$store.state.userName,
        deptCode: null,
        workDept: null,
        workJob: null,
      }
    },
    filters: {
      format_path(value){
        if(value){
          value = value.substring(1);
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.initLoadDate();
        this_.current_router_path = this_.$route.meta.parentPath?this_.$route.meta.parentPath:this_.$route.path;
      });
    },
    methods: {
      /**
       * 初始化加载数据
       */
      initLoadDate: function () {
        let this_ = this;
        this_.loadMenu();
      },
      /**
       * 手动改变菜单样式
       * @param path
       */
      changeMenuClass: function(path){
        let this_ = this;
        this_.current_router_path = path;
        if(path){
          path = path.substring(1);
        }
        //$(".router_link_div").removeClass("click_menu_option");
        $(".router_link_div[menuPathName="+path+"]").click();
      },
      /**
       * 加载菜单
       */
      loadMenu: function () {
        let this_ = this;
        schoolAxios({
          url: "role/index/getUserInfo",
          method: 'get',
          params: {}
        }).then(function (response) {
          let data = response.data;

          let menuList = data.list;

          if(this_.userCode.split(",").length != 1){
            if(this_.userCode.indexOf(this_.leaderUserCode) != -1 || this_.userCode.indexOf(this_.easUserCode) != -1){
              for(let i = menuList.length - 1; i > 0; i--){
                if( menuList[i].code == "index_tea" || menuList[i].code == "task_tea"){
                  menuList.splice(i, 1);
                }
              }
            }
            if(this_.userCode.indexOf(this_.easUserCode) != -1 && this_.userCode.indexOf(this_.teacherUserCode) != -1){
              for(let i =  0; i < menuList.length; i++){
                if(menuList[i].code == "index_tea"){
                  menuList.splice(i, 1);
                }
              }
            }
          }



          //this_.userName = this_.$store.state.loginUserName;
          this_.deptCode = data.data.deptCode;
          this_.workDept = data.data.deptName;
          this_.workJob = data.data.job;

          //班主任
          if(this_.userCode.indexOf(this_.teacherClassUserCode) == -1 && this_.teacherClazzCode == 1){
            menuList.push(this_.classManageTea);
          }
          this_.menu_data = menuList;

        /*  if(this_.userCode.split(",").length != 1){
            if(this_.userCode.indexOf((this_.teacherClassUserCode) == -1 && this_.teacherClazzCode ==1) || this_.userCode.indexOf(this_.easUserCode) !== -1  ){
              for(let i = menuList.length - 1; i > 0; i--){
                if(menuList[i].code == "classTea"){
                  menuList.splice(i, 1);
                  console.log(menuList);
                }
              }
            }
          }*/

          //保存或修改用户对象

          this_.$store.set("deviceToken", data.data.deviceToken);

          //this_.getUserData();
        });
      },
      /**
       * 获得studentId
       */
      /*getUserData(){
        let this_ = this;
        schoolAxios({
          url: "role/index/judgementRole",
          method: 'post',
          data: {}
        }).then(function (response) {
          let data = response.data;
          //保存或修改用户对象
          if (!window.sessionStorage) {
            "浏览器不支持sessionStorage".showMessage();
          } else {
            let storage = window.sessionStorage;
            storage["studentId"] = data.data.studentId;
            storage["userCode"] = data.data.userCode;
          }
          //重新保存用户对象
          this_.$store.commit('changeUserData');

          //如果路由地址是“/”则跳转至首页
          if(this_.$route.path && this_.$route.path == '\/'){
            switch (data.data.userCode){
              case this_.$store.state.easUserCode://教务
                this_.$router.push({
                  path: "/index"
                });
                this_.current_router_path = "/index";
                break;
              case this_.$store.state.teacherClassUserCode://班主任
                this_.$router.push({
                  path: "/noRight"
                });
                break;
              case this_.$store.state.teacherUserCode://批改老师
                this_.$router.push({
                  path: "/index_tea"
                });
                this_.current_router_path = "/index_tea";
                break;
              case this_.$store.state.studentUserCode://学员
                this_.$router.push({
                  path: "/index_stu"
                });
                this_.current_router_path = "/index_stu";
                break;
              default:
                this_.$router.push({
                  path: "/noRight"
                });
                break;
            }
          }
        });
      },*/
      /**
       * 修改密码
       */
      updateUserPassword: function () {
        $("#myModal_updatePassword").modal("show");
      },
      /**
       * 提交修改密码
       */
      updatePwd: function () {
        let this_ = this;
        if (this_.newPassword != this_.confirmNewPassword) {
          "两次输入的密码不一致!".showMessage();
          return;
        }
        schoolAxios({
          url: 'plat/user/personalInfo/updateManagerPwd',
          data: {
            'password': this_.oldPassword,
            'resetPassword': this_.newPassword
          }
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          //数据处理
        });
      },
      /**
       * 退出系统
       */
      existSystem: function () {
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'user/logout',
          data: {
          }
        }).finally(function (response) {
          this_.$store.set("loginUserName", '');
          this_.$store.set("userLoginStatus", false);
          this_.$store.set("token_type", '')
          this_.$store.set("access_token", '');
          this_.$store.set("refresh_token", '');
          this_.$store.set("expires_in", '');
          this_.$store.set("userName", '');
          this_.$store.set("userId", '');
          this_.$store.set("userCode", '');

          this_.$router.push({
            path: '/login'
          });

        });


      }
    },
  }

  /**
   * 根据浏览器的屏幕的大小自动调配div的大小
   */
  export function getContentSize() {
    let wh = document.documentElement.clientHeight;
    //头部div高度
    let eh = 62;
    //下部分高度
    let main_ch = (wh - eh + 2) + "px";
    if (document.getElementById("grid_left_div")) {
      document.getElementById("grid_left_div").style.height = main_ch;
    }
    if (document.getElementById("grid_right_div")) {
      document.getElementById("grid_right_div").style.height = main_ch;
    }
  }
  window.onload = getContentSize;
  window.onresize = getContentSize;
</script>

<style scoped>
  @import "../assets/css/mainView.css";
  @import "../assets/css/publicStyle.css";
</style>



// WEBPACK FOOTER //
// src/components/mainView.vue